import { useAuthContext } from '~/src/context/AuthProvider'

/**
 * Hook to check if the current user has a pro subscription
 * @returns boolean indicating if the user has a pro subscription
 */
export default function useHasProSubscription(): boolean {
  const { userData } = useAuthContext()

  const subscription = userData?.metadata?.subscription as
    | {
        plan?: string
        paymentStatus?: string
      }
    | null
    | undefined

  // User has pro subscription if they have a subscription with plan 'pro' and paymentStatus 'paid'
  return (
    !!subscription &&
    subscription.plan === 'pro' &&
    subscription.paymentStatus === 'paid'
  )
}
